import FeaturesMap from "@resources/psm-client-features.json";

export const FEATURES_MAP = FeaturesMap;
export const FEATURES = Object.keys(FEATURES_MAP);

export const FEATURE_OVERRIDE_PARAM_PREFIX = "b_feature_";
export const TRUTHY_VALUES = ["1", "y", "yes", "true"];
export const FALSY_VALUES = ["0", "n", "no", "false"];
